import React from "react"
import styled from 'styled-components'
import get from 'lodash/get'
import shortid from 'shortid'
import { CustomInput, Label, Input, Button } from 'reactstrap'
import DatePicker from 'react-datepicker'
import SearchIcon from '../../../static/images/search_icon.svg'
import { FONTS, COLORS } from '../../../constants'

export default class SearchbarReport extends React.Component {
  render() {
  /* eslint no-underscore-dangle: 0 */
    return (
      <Wrapper>
        <WrapperButton>
          <Col>
            <SearchField
              value={ get(this.props, 'search') }
              onChange={ get(this.props, 'handleSearch') }
              onKeyDown={ get(this.props, 'handleSearch') }
              placeholder='Search'
            />
          </Col>
          <Col>
            <Text>Date:</Text>
            <YOSDatePicker
              autoComplete='off'
              onChange={ get(this.props, 'handleChangeDate') }
              name="date"
              placeholderText='DD/MM/YYYY'
              selected={ get(this.props, 'date') === '' ? '' : get(this.props, 'date') }
              dateFormat="DD/MM/YYYY"
              showYearDropdown
              showMonthDropdown
            />
          </Col>
          <Col>
            <Text>Company:</Text>
            <CustomInputField
              type="select"
              value={ get(this.props, 'selectedCompany') }
              onChange={ get(this.props, 'handleCompany') }
            >
              { get(this.props, 'companys') &&
                get(this.props, 'companys').map((g) => <option key={ shortid() } value={ g._id }>{ g.name }</option>)
              }
            </CustomInputField>
          </Col>
          <Col>
            <Text>LOB:</Text>
            <CustomInputField
              type="select"
              value={ get(this.props, 'selectedLOB') }
              onChange={ get(this.props, 'handleLOB') }
            >
              {
                get(this.props, 'lobs') && get(this.props, 'lobs').map((g) => <option key={ shortid() } value={ g._id }>{ g.name }</option>)
              }
            </CustomInputField>
          </Col>
        </WrapperButton>
        <CustomButton
          bg={ COLORS.UPLOAD_COLOR }
          border={ COLORS.UPLOAD_COLOR_BORDER }
          onClick={ get(this.props, 'export') }
        >
          Export
        </CustomButton>
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  background-color: #ffffff;  
  height: 60px;
  position: relative;
  width: 100%;
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex: 1;
  align-items: center;
  box-shadow: 0px 3px 10px -7px black;
`
const WrapperButton = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1%;
  margin-right: 1%;
`
const Col = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  margin-right: 5px;
`
const SearchField = styled(Input)`
  height: 30px;
  width: 300px;
  padding-left: 30px;
  margin-top: 20px;
  background: url(${SearchIcon}) no-repeat scroll 3%;
  background-size: 15px 15px;
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  border: 1px solid #ccc;
  border-radius: 4px;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
  ::placeholder {
    color: #CCCCCC;
  }
`
const YOSDatePicker = styled(DatePicker)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  width: 100%;
  height : 30px;
  padding-left: 5%;
  padding-right: 5%;
  border-radius: 5px;
  border: 1px solid #CCCCCC;
`
const CustomInputField = styled(CustomInput)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  width: 100%;
  height : 30px;
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  background-color: ${props => { return props.bg }};
  width: 100px;
  height: 30px;
  margin-right: 10px;
  margin-top: 20px;
  color: white;
  border-color: ${props => props.border};
  border-radius: 4px;
  position: relative;
  &:hover {
    background-color: #333333;
    color: #ffffff;
    border-color: #CCCCCC;
  }
`
const Text = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.SMALL_SIZE};
  margin-bottom: 0px;
`



// WEBPACK FOOTER //
// ./src/components/searchbar-report/year-of-service/index.js